import { supabase } from "@/supabase";
import { debounce } from '@/utils/index';


export async function carregarDisciplinasDaArea(areaId) {
    const { data, error } = await supabase
        .from("disciplinas")
        .select('*')
        .eq('id_area', areaId);

    if (error) {
        console.log(error.message);
        return [];
    }

    return data;
}


export async function carregarParecerMinimo(trimestre, ano, area) {
    const { data, error } = await supabase
        .from('parecer_coisa_minima')
        .select("id, texto, area, trimestre, ano")
        .eq('trimestre', trimestre)
        .eq('ano', ano)
        .eq('area', area)
        .limit(1);

    if (error) {
        console.log(error.message);
        return false; 
    }

    if (data.length > 0) {
        return criarObjetoParecer(data[0], 'salvo');
    } else {
        // Retorna um objeto inicializado quando nenhum dado é encontrado
        return {
            id: null,
            status: 'novo',
            texto: "",
            trimestre: trimestre, 
            ano: ano,            
            area: area           
        };
    }
}



export const salvarParecerMinimoFetch = debounce(async function (parecer) {
    const {data, error} = await supabase
        .from('parecer_coisa_minima')
        .insert({
            texto: parecer.texto,
            area: parecer.area,
            trimestre: parecer.trimestre,
            ano: parecer.ano
        })
        .select();

    if (error) {
        console.log(error.message);
        return false;
    }

    return data[0].id;
},2000);


export const atualizarParecerMinimoFetch = debounce(async function(item){
    const {data, error} = await supabase
    .from('parecer_coisa_minima')
    .update({texto: item.texto})
    .eq('id', item.id)

    if (error) {
        console.log(error.message);
        return false;
    }
},2000)


function criarObjetoParecer(data, status) {
    return {
        id: data.id,
        status: status,
        texto: data.texto,
        trimestre: data.trimestre,
        ano: data.ano,
        area: data.area,
    };
}


export async function carregarObjetivosArea(trimestre, ano, disciplinas) {
    const idsDisciplinas = disciplinas.map(item => item.id);

    let { data, error } = await supabase
        .from('parecer_objetivo_area')
        .select('id, texto, trimestre, disciplina, ano')
        .eq('trimestre', trimestre)
        .eq('ano', ano)
        .in('disciplina', idsDisciplinas);

    if (error) {
        console.log(error);
        return null;
    }

    if (data.length === 0) {
        // Inicializa os objetivos se não houver dados retornados
        return disciplinas.map(disciplina => ({
            texto: '',
            trimestre: trimestre,
            ano: ano,
            disciplina: disciplina.id,
            disciplinaNome: disciplina.nome,
            status: 'novo'
        }));
    } else {
        // Processa os dados existentes
        data = data.map(objetivo => {
            const disciplina = disciplinas.find(d => d.id === objetivo.disciplina);
            objetivo.disciplinaNome = disciplina ? disciplina.nome : 'Desconhecido';
            objetivo.status = "salvo";
            return objetivo;
        });
    }

    return data;
}


export const salvarObjetivosArea = debounce(async function (objetivosArea) {
    // Filtra objetivos novos para inserção
    const novosObjetivos = objetivosArea.conteudo.filter(obj => obj.status === 'novo').map(objetivo => ({
        texto: objetivo.texto,
        trimestre: objetivo.trimestre,
        ano: objetivo.ano,
        disciplina: objetivo.disciplina
    }));

    // Filtra objetivos modificados para atualização
    const modificadosObjetivos = objetivosArea.conteudo.filter(obj => obj.status === 'modificado');

    try {
        // Insere novos objetivos se houver algum
        if (novosObjetivos.length > 0) {
            const { error } = await supabase
                .from('parecer_objetivo_area')
                .insert(novosObjetivos);

            if (error) {
                console.error('Erro ao inserir novos objetivos:', error);
                return false;
            }

            console.log('Novos objetivos inseridos com sucesso');

            return 'novosObjetivosSalvos';
            
        }

        // Atualiza objetivos modificados se houver algum
        if (modificadosObjetivos.length > 0) {
            for (const objetivo of modificadosObjetivos) {
                const { error } = await supabase
                    .from('parecer_objetivo_area')
                    .update({
                        texto: objetivo.texto,
                        trimestre: objetivo.trimestre,
                        ano: objetivo.ano,
                        disciplina: objetivo.disciplina
                    })
                    .eq('id', objetivo.id);

                if (error) {
                    console.error('Erro ao atualizar objetivo:', error);
                    return false;
                }
                console.log('Objetivo atualizado com sucesso');
            }
        }

        return true; // Retorna true se todas as operações foram bem-sucedidas
    } catch (err) {
        console.error('Erro durante a operação de salvar objetivos:', err);
        return false;
    }
}, 2000)


export async function carregarCompetencias(disciplinas, trimestre, ano){
    const idsDisciplinas = disciplinas.map(item => item.id);
    const {data, error} = await supabase
    .from('parecer_competencias')
    .select('*')
    .eq('ano', ano)
    .eq('trimestre', trimestre)
    .in('disciplina', idsDisciplinas)
    .order('disciplina', { ascending: true })

    if(error){
        console.log(error.message)
        return false;
    }

    if(data.length > 0){
        return criarObjetoCompetencia(data, 'salvo');
    }
    return []
}
export async function carregarCompetenciasPorTrimestre(disciplinas, trimestre, ano) {
    console.log('chamou')
    const idsDisciplinas = disciplinas.map(item => item.id);
    const { data, error } = await supabase
        .from('parecer_competencias')
        .select('*')
        .eq('trimestre', trimestre)
        .eq('ano', ano)
        .in('disciplina', idsDisciplinas)
        .order('disciplina', { ascending: true })

    if (error) {
        console.log(error.message)
        return false;
    }

    if (data.length > 0) {
        console.log(data)
        return criarObjetoCompetencia(data, 'salvo');
    }
    return []
}

export const salvarCompetenciaFetch = debounce(async function(item){

    const { data, error } = await supabase
        .from('parecer_competencias')
        .insert({
            competencia: item.competencia,
            trimestre: item.trimestre,
            ano: item.ano,
            disciplina: item.disciplina
        })
        .select()

    if (error) {
        console.error('Erro ao atualizar objetivo:', error);
        return false;
    }

    return data[0].id;

},2000)

export const atualizarCompetenciaFetch = debounce(async function (item){
    console.log(item)
    const { data, error } = await supabase
        .from('parecer_competencias')
        .update({competencia: item.competencia, disciplina: item.disciplina})
        .eq('id', item.id)

    if (error) {
        console.error( error.message);
        return false;
    }

}, 2000)

export async function excluirCompetenciaFetch(id) {
    const { error} = await supabase
    .from('parecer_competencias')
    .delete()
    .eq('id', id)

    if(error){
        console.error('Erro durante a operação de salvar objetivos:', error);
        return false;
    }
}


function criarObjetoCompetencia(competencias, status) {
    return competencias.map(item => ({
        id: item.id,
        competencia: item.competencia,
        trimestre: item.trimestre,
        ano: item.ano,
        disciplina: item.disciplina,
        status: status 
    }));
}

export async function carregarSugestoesFetch(area, trimestre, ano){
    const {data, error} = await supabase
    .from('parecer_sugestoes_melhoria')
    .select('*')
    .eq('area', area)
    .eq('trimestre', trimestre)
    .eq('ano', ano)

    if(error){
        console.log(error.message);
        return false;
    }

    return data.length > 0 ? criarObjetoSugestao(data, 'salvo') : [];
}

export const salvarSugestaoFetch = debounce(async function(item){
    const {data, error} = await supabase
    .from('parecer_sugestoes_melhoria')
    .insert({sugestao: item.sugestao, trimestre: item.trimestre, ano: item.ano, area: item.area, criterio: item.criterio})
    .select()

    if(error){
        console.log(error.message);
        return false
    }
    return data[0].id

}, 2000)

export const atualizarSugestaoFetch = debounce(async function (item) {
    const {error} = await supabase
    .from('parecer_sugestoes_melhoria')
    .update({sugestao: item.sugestao, criterio: item.criterio})
    .eq('id', item.id)

    if (error) {
        console.log(error.message);
        return false
    }

}, 2000)

export async function excluirSugestaoFetch(id) {
    const {error} = await supabase
    .from('parecer_sugestoes_melhoria')
    .delete()
    .eq('id', id)

    if (error) {
        console.log(error.message);
        return false
    }
}


function criarObjetoSugestao(sugestoes, status){
    return sugestoes.map(item => ({
       id: item.id,
       sugestao: item.sugestao,
       trimestre: item.trimestre,
       ano: item.ano,
       area: item.area,
       criterio: item.criterio,
       status: status

    }))
}


export async function salvarPareceres(pareceres) {

    const { data, error } = await supabase
        .from('pareceres')
        .insert(pareceres)
    if (error) {
        console.log(error.message)
        return
    }
    


}

export async function carregarPareceres(anoLetivo, areaDoConhecimento, trimmestresSelecionados, estudantes) {
    
    const { data, error } = await supabase
        .from('pareceres')
        .select('*, users(nome)')
        .eq('anoLetivo', anoLetivo)
        .eq('area', areaDoConhecimento)
        .in('trimestre', trimmestresSelecionados)
        .in('estudante', estudantes)

    if (error) {
       
        alert('Ocorreu um erro ao carregar os pareceres. Experimento recarregar a página ' + error.message)
        return
    }
  
    return data

}

export async function excluirPareceres(pareceres){
   
    const { error } = await supabase
        .from('pareceres')
        .delete()
        .in('id', pareceres)
    
        if(error){
            
            console.error(error.message);
        }
        return true
}